// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ep-a";
export var fulfillmentFormRail = "_ep-9";
export var headerTitleRow = "_ep-c";
export var orderDetailsWrapper = "_ep-7";
export var orderLinkTrigger = "_ep-2";
export var paymentInformationGrid = "_ep-h";
export var paymentSummaryColumn = "_ep-i";
export var shipmentContainer = "_ep-b";
export var shipmentDetailsMainPane = "_ep-8";
export var shipmentNavigationCard = "_ep-5";
export var shipmentNavigationRail = "_ep-3";
export var shipmentNavigationRailHeader = "_ep-4";
export var shipmentSummaryFact = "_ep-e";
export var shipmentSummaryGrid = "_ep-d";
export var shipmentSummaryMetadataRow = "_ep-f";
export var shipmentSummaryTags = "_ep-g";
export var shipmentWorkspace = "_ep-0";
export var shipmentWorkspaceContent = "_ep-6";
export var shipmentWorkspaceHeader = "_ep-1";